export default "__VITE_ASSET__d06c189e__"